<template>
  <div>
    <h2 class="title is-4">Probes</h2>
    <div class="columns">
      <div class="column is-3">
        <h3 class="title is-5">
          Number of Probes
          <font-awesome-icon
            icon="info-circle"
            title="Optional. The absolute maximum of selected results will be calculated within a volume surrounding the phantom. Using probes, it is possible to define up to 5 additional points where results are extracted."
            style="cursor: help;"
          />
        </h3>
        <div class="select">
          <select v-model="numProbes" id="step4-num-probes-select">
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select>
        </div>
      </div>
      <div v-if="numProbes>0" class="column is-3">
        <h3 class="title is-5">x Coordinates</h3>
        <Field
          v-for="(probeNumber, probeIndex) in iterProbes"
          v-bind:key="probeIndex"
          v-bind:name="'x<sub>' + probeNumber + '</sub>'"
          v-model="probeCoordinates[probeIndex][0]"
          v-bind:vmin="-probeBoundaries.X"
          v-bind:vmax="probeBoundaries.X"
          @fieldEvent="onChange"
          units="mm"
          v-bind:id="'step4-coordinate-x-' + probeNumber"
        />
      </div>
      <div v-if="numProbes>0" class="column is-3">
        <h3 class="title is-5">y Coordinates</h3>
        <Field
          v-for="(probeNumber, probeIndex) in iterProbes"
          v-bind:key="probeIndex"
          v-bind:name="'y<sub>' + probeNumber + '</sub>'"
          v-model="probeCoordinates[probeIndex][1]"
          v-bind:vmin="-probeBoundaries.Y"
          v-bind:vmax="probeBoundaries.Y"
          @fieldEvent="onChange"
          units="mm"
          v-bind:id="'step4-coordinate-y-' + probeNumber"
        />
      </div>
      <div v-if="numProbes>0" class="column is-3">
        <h3 class="title is-5">z Coordinates</h3>
        <Field
          v-for="(probeNumber, probeIndex) in iterProbes"
          v-bind:key="probeIndex"
          v-bind:name="'z<sub>' + probeNumber + '</sub>'"
          v-bind:vmin="-probeBoundaries.Z"
          v-bind:vmax="probeBoundaries.Z"
          v-model="probeCoordinates[probeIndex][2]"
          @fieldEvent="onChange"
          units="mm"
          v-bind:id="'step4-coordinate-z-' + probeNumber"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Field from '@/components/Simulation/Field.vue';

export default {
  components: {
    Field,
  },
  data() {
    return {
      numProbes: 0,
      probeBoundaries: {
        X: 220,
        Y: 45,
        Z: 325, // mm
      },
      probeCoordinates: [
        ['', '', ''],
        ['', '', ''],
        ['', '', ''],
        ['', '', ''],
        ['', '', ''],
      ], // 2d array with dimensions N x 3 for N probes in |R3
    };
  },
  computed: {
    iterProbes() {
      const probes = parseInt(this.numProbes, 10);
      const arr = new Array(probes);
      for (let i = 0; i < arr.length; i += 1) {
        arr[i] = i + 1; // can be consumed by template
      }
      return arr;
    },
  },
  methods: {
    onChange() {
      const probes = parseInt(this.numProbes, 10);
      if (probes === 0) {
        this.$emit('probeEvent', null);
      } else {
        const coordinates = [];
        for (let i = 0; i < probes; i += 1) {
          // inputs are strings so we convert
          coordinates.push({
            X: this.probeCoordinates[i][0],
            Y: this.probeCoordinates[i][1],
            Z: this.probeCoordinates[i][2],
          });
        }
        this.$emit('probeEvent', coordinates);
      }
    },
  },
  watch: {
    numProbes() {
      this.onChange();
    },
  },
};
</script>

<style>
</style>
